import { render, staticRenderFns } from "./Level4-2.vue?vue&type=template&id=851abd76&scoped=true&"
import script from "./Level4-2.vue?vue&type=script&lang=js&"
export * from "./Level4-2.vue?vue&type=script&lang=js&"
import style0 from "./Level4-2.vue?vue&type=style&index=0&id=851abd76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851abd76",
  null
  
)

export default component.exports